export const environment = {
  production: true,
    API_URL: 'https://back.evocredito.corefluens.co/api/',
    enterprise: "evocredito",
    api_username: 'evocredito',
    api_password: 'y3V5VVrOR7bpRU1',
    enable_seas: false
};
